module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row-red-nav"
  }, [_c('div', {
    staticClass: "main-width"
  }, [_c('ul', {
    staticClass: "list-basic-settings",
    attrs: {
      "id": "red-nav-navbar"
    }
  }, [_c('li', [_c('a', {
    staticClass: "row-red-nav-a",
    attrs: {
      "href": "home.html"
    }
  }, [_vm._v("首页")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "row-red-nav-a",
    attrs: {
      "href": "purchase.html"
    }
  }, [_vm._v("物资招标")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "row-red-nav-a",
    attrs: {
      "href": "logisticses.html"
    }
  }, [_vm._v("工程招标")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "row-red-nav-a",
    attrs: {
      "href": "engineering.html"
    }
  }, [_vm._v("服务招标")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "row-red-nav-a",
    attrs: {
      "href": "http://www.csc100.com/",
      "target": "_blank"
    }
  }, [_vm._v("返回官网")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e16997a8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/G-rednav.vue
// module id = 18
// module chunks = 1 5 6 7 8 9 10 11 12 13 14 15 16 17